import { formatDate, prettyValue } from "../utils/formatters";
import { fileStatusLabel, stepStatusLabel } from "../api/filePacket/constants";
import { REPORT_DISCLAIMER } from "./reportModel";

function formatStamp(iso) {
  if (!iso) return "";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return `${formatDate(iso)} · ${date.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" })}`;
}

export function buildFilePacketModel(file, extras = {}) {
  const profile = file.clientProfile || {};
  const generatedAt = formatStamp(new Date().toISOString());

  return {
    title: "DreamHome Journey",
    subtitle: "File packet",
    property: file.propertyAddress || profile.address || profile.name || "Client file",
    status: fileStatusLabel(file.status) || file.status || "",
    clientRole: file.fileType || "",
    generatedAt,
    exportType: extras.exportType || "packet",
    generatedBy: extras.generatedBy || "",
    parties: {
      broker: profile.broker,
      agent: profile.agent,
      client: profile.name,
    },
    partyEmails: {
      broker: "",
      agent: "",
      client: profile.email || "",
    },
    clientPhone: profile.phone || "",
    clientAddress: profile.address || file.propertyAddress || "",
    clientNotes: profile.notes || file.specialNotes || "",
    timeline: (file.messages || []).map((item) => ({
      at: item.at,
      stamp: item.stamp,
      senderName: item.title,
      text: item.text,
      attachments: item.attachments || [],
    })),
    attachments: (file.attachments || []).map((fileItem) => ({
      name: fileItem.name,
      type: fileItem.type,
      stamp: fileItem.stamp,
      senderName: fileItem.source || "",
    })),
    checklistType: file.fileType || "buyer",
    checklistHeading: file.fileType === "seller" ? "Seller checklist pages" : "Buyer checklist pages",
    checklistSections: file.checklistSections || [],
    pageNotes: file.pageNotes || [],
    tips: file.tips || [],
    specialNotes: file.specialNotes || "",
    transactionMilestones: (file.transactionTimeline || []).map((item) => ({
      title: item.title,
      status: prettyValue(item.status) || "Not started",
      detail: item.detail || "",
    })),
    customSteps: (file.customSteps || []).map((step) => ({
      title: step.title,
      status: stepStatusLabel(step.status),
      date: step.date || "",
      description: step.description || "",
      notes: step.notes || "",
      attachments: (step.attachments || []).map((item) => item.file_name || item.name).filter(Boolean),
    })),
    lifecycle: (file.lifecycle || []).map((stage) => ({
      title: stage.title,
      status: stepStatusLabel(stage.status),
      notes: stage.notes || "",
    })),
    calendarEvents: (file.calendarEvents || []).map((event) => ({
      title: event.title,
      when: [event.date, event.time].filter(Boolean).join(" · "),
      type: prettyValue(event.type),
      location: event.location || "",
      notes: event.notes || "",
    })),
    actionTimeline: (file.timeline || []).map((item) => ({
      stamp: item.stamp,
      source: prettyValue(item.source),
      title: item.title,
      text: item.text,
    })),
    packet: true,
    pageFooter: "DreamHome Journey · file packet",
    disclaimer: REPORT_DISCLAIMER,
  };
}
